import $ from 'jquery'
import ManageParamSagefemme from '@/views/parametres/configs/param-sagefemme/manage-param-sagefemme'

export default {
    name: 'param-exploration-col',
    components: {
        ManageParamSagefemme
    },
    props: {
        params_cpn: Object,
    },
    data() {
        return {
            fields: [
				'libelle',  { key: 'actions', label: 'Action.s' }
			],
			perPage: -1,
			currentPage: 1,
            is_empty: false,

            toggler: 0,
            del_toggler: 0,
            selected_section: {
                data_type: '',
                label: ''
            },
            selected_param: null
        }
    },

    watch: {

    },

    computed: {

    },

    mounted() {

    },

    methods: {
        openAddParamModal(data_type, label, param = null) {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_section = {
                data_type: data_type,
                label: label
            }
            this.selected_param = param

            $('.param-sagefemme-modal').modal('show')
        },

        openEditParamModal(data_type, label, param) {
            this.openAddParamModal(data_type, label, param)
        },

        openDeleteParamModal(data_type, label, param) {
            this.del_toggler = (this.del_toggler == 0)?1:0
            this.selected_section = {
                data_type: data_type,
                label: label
            }
            this.selected_param = param

            $('.param-sagefemme-del-modal').modal('show')
        }
    }
}